import type { ToolDefinition } from "../types";
import optimizeSeoResponsiveImageTool from "./optimize-seo-responsive-image";
import faviconGeneratorTool from "./favicon-generator";

export const seoTools: ToolDefinition[] = [
  optimizeSeoResponsiveImageTool,
  faviconGeneratorTool,
];

export { default as optimizeSeoResponsiveImageTool } from "./optimize-seo-responsive-image";
export { default as faviconGeneratorTool } from "./favicon-generator";
